"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gleam = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _Gleam = require("./Gleam.styles");
var _GleamWrapper = require("./GleamWrapper.styles");
var _excluded = ["children", "count", "maxCount", "maxSuffix"];
/**
 * @since 7.39.0
 */
var Gleam = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    count = _ref.count,
    maxCount = _ref.maxCount,
    maxSuffix = _ref.maxSuffix,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var value = count;
  if (maxCount && count > maxCount) {
    value = maxCount;
    if (maxSuffix) {
      value += '+';
    }
  }
  var gleam = /*#__PURE__*/_react.default.createElement(_Gleam.StyledGleam, (0, _extends2.default)({}, rest, {
    ref: forwardedRef
  }), value);
  if (typeof children !== 'undefined') {
    return /*#__PURE__*/_react.default.createElement(_GleamWrapper.StyledGleamWrapper, null, children, gleam);
  }
  return gleam;
});
exports.Gleam = Gleam;
Gleam.displayName = 'Gleam';
Gleam.Wrapper = _GleamWrapper.StyledGleamWrapper;
Gleam.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The type of gleam to display.
   */
  appearance: _propTypes.default.oneOf(Object.values(_constants.GLEAM_STATUS_TYPES)),
  /**
   * Postion the gleam relative to the children content.
   */
  children: _propTypes.default.node,
  /**
   * The notification count displayed on the badge
   */
  count: _propTypes.default.number.isRequired,
  /**
   * Inverse colors for use on dark or colored backgrounds.
   */
  inverse: _propTypes.default.bool,
  /**
   * If `count` is greater than `maxCount`, the badge will display `maxCount` instead.
   * You can disable a max by setting this to 0.
   */
  maxCount: _propTypes.default.number,
  /**
   * If `count` is greater than `maxCount`, the badge will display `maxCount` with a `+` suffix.
   */
  maxSuffix: _propTypes.default.bool
} : {};
Gleam.defaultProps = {
  appearance: _constants.GLEAM_STATUS_TYPES.DEFAULT,
  children: undefined,
  inverse: false,
  maxCount: 99,
  maxSuffix: false
};